import { useTranslation } from 'react-i18next';
import { CraftAssetDownload } from '#pie/components/craft-asset-download/CraftAssetDownload';
import type { Option } from '#pie/components/input-radio/InputRadio';
import type { CreateDataRequestDto } from '#pie/internal/api/pie-bff';
import { AddressLevel, DataLevel } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormRadio, FormFile } =
  typedFormFields<CreateDataRequestDto>();

export const LevelAddress = () => {
  // Stuur lijst met adres(sen) mee in Excel formaat; Adres?
  const { t } = useTranslation('dataRequest');
  const options: Option[] = [
    {
      label: t(`address_level.${AddressLevel.Individual}`),
      tooltip: t('level_address_tooltip'),
      value: AddressLevel.Individual,
    },
    {
      label: t(`address_level.${AddressLevel.Cluster}`),

      value: AddressLevel.Cluster,
    },
  ];
  return (
    <>
      <ConditionalField
        field="addressFile"
        condition={(fieldValue) => fieldValue('level') === DataLevel.Address}
      >
        <FormFile
          label={t('address_level_file')}
          name="addressFile"
          rules={{ required: true }}
        />
        <CraftAssetDownload title="Aanleveren clusters voorbeeldbestand" />
      </ConditionalField>
      <ConditionalField
        field="addressLevel"
        condition={(fieldValue) => fieldValue('level') === DataLevel.Address}
      >
        <FormRadio
          label={t('address_level')}
          name="addressLevel"
          options={options}
          rules={{ required: true }}
        />
      </ConditionalField>
    </>
  );
};
